module.exports = __webpack_public_path__ + "img/southafrica-flag.c86aa433.svg";